define('views/ProjectsView',[
    'backbone',
    'lodash',
    'text!templates/projects.html',
    'app',
    'lib/MouseAnim',
    'lib/easing'
], function (Backbone, _, projectsTmpl, App, MouseAnim, easing) {

    "use strict";

    return Backbone.View.extend({

        tagName: 'article',

        template: _.template(projectsTmpl),

        events: {
            'click .filter-control button': 'filter'
        },

        initialize: function () {
            // group project by location
            this.locations = _.groupBy(App.projects, 'location');

            this.projects = App.projects;
            this.current = '';
        },

        render: function () {
            this.$el.html(this.template(App));
            if (App.projects.length) {
                this.initAnim();
            }
        },

        filter: function (event) {
            var location = event.currentTarget.value;

            if (this.mouseAnim) {
                this.mouseAnim.destroy();
            }
            this.projects = location ? this.locations[location] : App.projects;
            this.current = location;
            this.render();
        },

        initAnim: function () {
            this.mouseAnim = new MouseAnim();
            var $block = this.$el.find('.col-sm-4 .block'),
                gutter = 15, // gutter width between blocks
                $clips = this.$el.find('.svg-clip polygon'),
                $lfTri = this.$el.find('.right-tri.left-top'),
                $rtTri = this.$el.find('.right-tri.right-bottom');

            if (this.projects.length === 1) {
                return false;
            }

            this.mouseAnim.add(function (pos) {
                var progress = (pos.mouseSrnPos.x + pos.mouseSrnPos.y) / (window.innerWidth + window.innerHeight),
                    eased = easing.easeInOutQuad(progress),
                    blockW = $block[0].offsetWidth,
                    adjust = gutter / blockW * 100, // compensate for the gutter
                    leftTop = 30 + (40 * eased),
                    rightBottom = leftTop + adjust;

                // for performance
                leftTop = Math.round(leftTop);
                rightBottom = Math.round(rightBottom);

                // change clip
                $clips[0].setAttribute('points', '0,0 ' + leftTop + ',0, 0,' + leftTop);
                $clips[1].setAttribute('points', '100,' + rightBottom + ' 100,100 ' + rightBottom + ',100');

                if ($rtTri.length) {
                    var rtW = (1 - (rightBottom / 100)) * blockW;
                    $rtTri.css( 'width', Math.round(rtW) + 'px' );
                }
                if ($lfTri.length) {
                    var lfW = (leftTop / 100) * blockW;
                    $lfTri.css( 'width', Math.round(lfW) + 'px' );
                }
            });
        },

        remove: function () {
            if (this.mouseAnim) {
                this.mouseAnim.destroy();
            }
            Backbone.View.prototype.remove.call(this);
        }

    });

});
